import React from 'react';
import Highcharts from 'highcharts/highcharts';
import HighchartsReact from 'highcharts-react-official';

import data_mg from './data_mg';
import pred_mg from './pred_mg';

import data_c from './data_c';
import pred_c from './pred_c';

const base = {
  credits: {
    enabled: false
  },
  plotOptions: {
    series: {
      enableMouseTracking: false,
      lineWidth: 1
    },
  },
  legend: {
    enabled: false,
  }
};

const options1 = {
  ...base,
  title: {
    text: 'Mackey-Glass',
    margin: 1,
    style: { fontSize: '12px' }
  },
  yAxis: {
    title: { enabled: false },
    min: -0.7,
    max: 0.5,
    tickInterval: 0.1
  },
  series: [
    {
      marker: { enabled: true, radius: 3 },
      data: data_mg.slice(6000, 6500).filter((_,i) => i % 4 === 0),
    },
    {
      marker: { enabled: true, radius: 3 },
      data: pred_mg.slice(4000, 4500).filter((_,i) => i % 4 === 0),
    },
  ]
};

const options2 = {
  ...base,
  title: {
    text: 'Chaotic Insulin-Glucose Model',
    margin: 1,
    style: { fontSize: '12px' }
  },
  yAxis: {
    title: { enabled: false },
    min: 9000,
    max: 14000,
    tickInterval: 1000
  },
  series: [
    {
      marker: { enabled: true, radius: 3 },
      data: data_c.slice(4900, 5000),
    },
    {
      marker: { enabled: true, radius: 3 },
      data: pred_c.slice(3900, 4000)
    },
  ]
};

const opts = { style: { height: '200px', width:'100%' }};

function Discussions() {
  return (
    <div className="row">
      <div className="col-12 col-xl-6 col-xxxl-4">
        <p>
          With the properly tuned parameters, we can predict our generated models to several thousand steps into the future using a much smaller pool of training data points.
        </p>
        <p>
          However, after thousands of steps, the predicted model begins to drift from the underlying data while maintaining amplitude.
          More reservoir units lengthen the period of accurate predictions.
          Additionally, a chaotic Gaussian insulin-glucose model we generated could not be accurately predicted by our current reservoir past a couple dozen steps.
          We hope to study and understand the cause of these behaviors in future works.
        </p>
      </div>
      <div className="col-xl-6 col-xxxl-4">
        <div className="row">
          <div className="col-12 col-xxl-6">
            <HighchartsReact
              highcharts={Highcharts}
              options={options1}
              containerProps={opts}
            />
          </div>
          <div className="col-12 col-xxl-6">
            <HighchartsReact
              highcharts={Highcharts}
              options={options2}
              containerProps={opts}
            />
          </div>
        </div>
      </div>
      <div className="col-xl-12 col-xxxl-4">
        <p>
          We're currently studying the use of an <strong>interconnected system of reservoirs</strong> in predicting the decomposed system of delay differential equations that govern the insulin-glucose cycle.
        </p>
        <p>
          Additionally, we want to implement and train a <strong>convolutional training network</strong> (CNN) to recognize the parameters a reservoir needs to predict a series.
          The two parameters we configured, reservoir units and spectral radius, can not be exhaustively tuned due to the resources needed to generate large reservoirs.
          We hope to discover a trained solution for picking reservoir generation parameters.
        </p>
      </div>
    </div>
  );
}

export default Discussions;
